import _ from "lodash";
import {
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
} from "Constants/stringConstants";
import { CURRICULUM_PROGRAMS } from "Tooling/modules/ToolingUtils";

export const getCurriculumProgramOptions = ({ curriculumPrograms }) => {
  const curriculumProgramTypes = _.uniq(
    _.map(curriculumPrograms, ({ type }) => type)
  );

  return _.map(
    CURRICULUM_PROGRAMS,
    ({ type, value, label, variant, subtitle, normalisedLabel }) => {
      let isAvailable = true;
      switch (type) {
        case CURRICULUM_TYPE_PYP:
        case CURRICULUM_TYPE_UBD:
        case CURRICULUM_TYPE_MYP: {
          isAvailable = true;
          break;
        }

        case CURRICULUM_TYPE_DP: {
          isAvailable = !_.includes(curriculumProgramTypes, value);
          break;
        }
      }

      return {
        type,
        value,
        label,
        isAvailable,
        variant,
        subtitle,
        normalisedLabel,
      };
    }
  );
};
